export default "__VITE_ASSET__CoLck8$e__"